<style type="text/css">
  input[type="checkbox"][disabled] {
    /* outline: 2px solid red; */
    background-color: aqua !important;
    color: red;
  }
  .btn-style{
    font-size:12px !important;
    color: green;
    padding: 0px;
  }
</style>
<template>
  <form class="mt-2" id="form-modal">
    <!-- description input -->
    <div class="form-group">
      <div>
        <label class="label-form">Demo Date<span style="color: red">*</span>:</label>
        <input class="form-control" id="demo_date" v-model="demo_date" type="datetime-local" />
      </div>
      <br />
      <div class="d-flex">
        <div class="form-group col-12 p-0">          
          <label class="label-form">Contacts</label>
          <div v-for="(report, index) in contact_emails" :key="index" class="d-flex align-items-center mb-2">
                    <input
                    :id="'task-title-' + index"
                    type="text"
                    v-model="report.email"
                    class="form-control form-control-sm mr-2"
                    placeholder="Contacts" :readonly="index === 0"
                    />
                    <button 
                    type="button" 
                    class="btn add-more-cross-btn shadow-none btn-style"
                    @click="removeReport(index)"
                    :style="{ opacity: index === 0 ? '50%' : '100%', visibility: index === 0 ? 'hidden' : 'visible' }"
                    :disabled="contact_emails.length === 0"
                    >
                    <i  class="fas fa-trash text-dark"></i>
                    </button>
                </div>
                <button type="button" @click="addReport" class="btn add-more-btn btn-primary-sm shadow-none btn-style"> <span class="me-2 ">+ </span> Add More</button>
        </div>
      </div>
      <label class="label-form">Demo Note<span style="color: red">*</span>:</label>
      <textarea class="form-control" style="height: 200px" v-model="note_description"
        placeholder="write a note here for this Demo">
            {{ getNote }}</textarea>
    </div>
    <div>
        <!-- buttons -->
        <div class="text-right mb-3">
          <button v-if="flag" type="button" :style= "[isMiniLoading ? { 'cursor' : 'default' } : { 'cursor' : 'pointer' }]" :disabled="isMiniLoading" class="btn btn-success btn-block text-light py-2 btn-sm ml-1" @click="save">
            <font-awesome-icon v-if="isMiniLoading" icon="spinner" style="animation: spin 2s linear infinite; position: absolute; right: 40%; margin-top: 3px;" />
            Save
          </button>
          <button v-else type="button" :style= "[isMiniLoading ? { 'cursor' : 'default' } : { 'cursor' : 'pointer' }]" :disabled="isMiniLoading"  class="btn btn-success text-light btn-sm ml-1" @click="updateDemoNote">
            <font-awesome-icon v-if="isMiniLoading" icon="spinner" style="animation: spin 2s linear infinite; position: absolute; right: 40%; margin-top: 3px;" />
            Update
          </button>
        </div>
      <table class="table table-bordered table-hover">
        <colgroup>
          <col class="col-md-4" />
          <col class="col-md-12" />
        </colgroup>
        <tbody>
          <tr class="mt-2" v-for="(demo, index) in demo_notes" :key="demo.id">
            <td>
              <!-- <input type="checkbox" class="" v-if="demo_completed==demo.id" checked disabled >
                        <input type="checkbox" v-else disabled hidden >
                        <span class="" style="font-weight:bold;">{{demo.created_at}}</span> -->
              <div class="form-check">
                <input type="checkbox" class="form-check-input" v-if="demo.completed == 1" checked disabled />
                <input type="checkbox" class="form-check-input" v-else value="" id="" disabled />
                <label class="form-check-label font-weight-bold">
                  {{ demo.schedule_date | formatDate}}
                </label>
              </div>
            </td>
            <td>{{ demo.schedule_note }}</td>
            <td>
              <div class="btn-group">
                <a class="btn dropdown-toggle" data-toggle="dropdown" href="#">
                      <span class="fas fa-ellipsis-v"></span>
                </a>
                <ul class="dropdown-menu" style="min-width: 12rem !important">
                  <a class="dropdown-item" @click="updateIndex(index)">Edit</a>
                  <a :href="demo.meeting_link" v-if="demo.meeting_link" class="dropdown-item" target="_blank">Zoom Link</a>
                  <a class="dropdown-item disabled" v-if="demo.completed == 1">Completed</a>
                  <a class="dropdown-item disabled" v-if="demo.completed == 2">Incompleted</a>
                  <a class="dropdown-item"  v-if="demo.completed !== 1 && demo.completed !== 2" @click="completeDemo(index)">Complete</a>
                   <a class="dropdown-item"  v-if="demo.completed !== 1 && demo.completed !== 2" @click="incompleteDemo(index)" >Incomplete</a>
                </ul>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  
  </form>
</template>
<script>
  import axios from "axios";
  import completeDemo from "./complete_demo_form.vue";
   import incompleteDemo from "./incomplete_demo_form.vue";
  import moment from "moment";

  Vue.filter("formatDate", function (value) {
    if (value != "0000-00-00 00:00:00" && value != null) {
      return moment(String(value)).format("MMM DD, Y LT");
    }
  });

  export default {
    props: ["action", "formData"],
    data: function () {
      return {
        contact_emails:[{email:this.formData.email}],
        demo_date: "",
        note_description: "",
        isMiniLoading: false,
        demo_notes: "",
        id: "",
        flag: true,
        demo_completed: "",
        add_contact: true,
        getContact_emails: "",
        lead_stage_id: 0,
        // contact_emails: [this.formData.email]
      };
    },
    watch: {
      'formData.email': {
        handler(newVal) {
          if (newVal) {
            this.contact_emails = [{ email: newVal }];
          }
        },
        deep: true
      }
    },

    computed: {
      getNote: function () {
        this.note_description = "";
        this.demo_date = "";
          const permission = {
        headers: {
          'X-Permission': 'lead_set_demo_date' 
        }
      };
        axios
          .get("/admin/users/get-demo-note?user_id=" + this.formData.user,permission)
          .then((response) => {
            let data = response.data.demo_notes;
            if (data != null) {
              this.demo_notes = data;
            }
            this.flag = true;
            this.demo_date = new Date().toLocaleString("en-US", { timeZone: "US/Eastern" }); 
            this.demo_date = moment(String(this.demo_date)).format('YYYY-MM-DDThh:mm');
            this.demo_completed = localStorage.getItem("demo_completed");
          });
      },
    },
    methods: {
      addReport() {
            this.contact_emails.push({ email: ''}); // Add a new task with an empty title
            },
            removeReport(index) {
            if (this.contact_emails.length > 1) {
                this.contact_emails.splice(index, 1); // Remove the task at the specified index
            }
            },
      save() {
        this.isMiniLoading= true;
        let self = this;
        let page_no = self.formData.pageNumber;
        let note = self.note_description;
        let demo_date = self.demo_date;
        let contact_emails = this.contact_emails;
        let todayDate = new Date().toISOString().slice(0, 10);
        if (demo_date != "" && note.replace(/\s/g, "").length) {
          const permission = {
        headers: {
          'X-Permission': 'lead_set_demo_date' 
        }
      };
            axios
              .post("/admin/users/save-demo-date", {
                demo_id: self.formData.user,
                note: note,
                date: demo_date,
                contact_emails: contact_emails
                
              },permission)
              .then(() => {
                this.isMiniLoading = false;
                this.$toast.success("Demo Note has been added successfully");
                window.$("#modal").modal("hide");
                this.note_description = "";
                this.getDemoNote();
                this.$store.dispatch("users/getAllDemoRequests", [page_no, "",this.formData.status,  "",  "", "", "", "", "", this.formData.color ? this.formData.color : "", this.formData.followup_filter, 'all' ,'all' ]);
              })
              .catch((error) => {
                this.isMiniLoading = false;
                if (error.response) {
                  const errorMessage = error.response.data.message || 'An unexpected error occurred.';
                  this.$toast.error(errorMessage);
                } else if (error.request) {
                  this.$toast.error('No response received from the server.');
                } else {
                  this.$toast.error(error);
                }
              });
        } else {
          this.isMiniLoading = false;
          this.$toast.warning("Please Fill All Required Fields");
        }
      },
      add_contacts(){
        // this.contact_emails.push('');
      },
      updateIndex(demo_id) {
        this.id = this.demo_notes[demo_id].id;
        this.demo_date = this.demo_notes[demo_id].schedule_date;
        this.note_description = this.demo_notes[demo_id].schedule_note;
        this.getContact_emails = this.demo_notes[demo_id].contact_emails;
        this.getContact_emails = this.removeDuplicates(this.getContact_emails);
        this.lead_stage_id = this.demo_notes[demo_id].lead_stage_id;
        this.contact_emails = this.getContact_emails.split(',').map(email => ({ email: email.trim() }));
        this.flag = false;
      },
      removeDuplicates(emailsString) {
        let emailsArray = emailsString.split(',');
        let uniqueEmailsSet = new Set(emailsArray);
        let uniqueEmailsArray = Array.from(uniqueEmailsSet);
        let uniqueEmailsString = uniqueEmailsArray.join(',');
        return uniqueEmailsString;
      },
      updateDemoNote() {
        this.isMiniLoading = true;
        let page_no = this.formData.pageNumber;
        let note = this.note_description;
        let demo_id = this.id;
        let contact_mails = this.contact_emails;
        let lead_stages_id = this.lead_stage_id;
        let demo_date = this.demo_date;

        if (note.replace(/\s/g, "").length) {
            const permission = {
        headers: {
          'X-Permission': 'lead_set_demo_date' 
        }
      };
          axios
            .post("/admin/users/update-demo-note", { id: demo_id, note: note , date : demo_date, contact_emails: contact_mails, lead_stage_id: lead_stages_id },permission)
            .then((response) => {
              this.isMiniLoading = false;
              this.$toast.success("Demo Note has been Updated successfully");
              window.$('#modal').modal('hide');
              this.flag = true;
              this.note_description = "";
              this.getDemoNote();
              this.$store.dispatch("users/getAllDemoRequests", [
                page_no,
                "",
                this.formData.status,
                "",
                "",
                "",
                "",
                "",
                "",
                this.formData.color ? this.formData.color : "",
                this.formData.followup_filter,
                'all',
                'all',
              ]);
            })
            .catch((error) => {
              this.isMiniLoading = false;
                if (error.response) {
                  const errorMessageUpdate = error.response.data.message || 'An unexpected error occurred.';
                  this.$toast.error(errorMessageUpdate);
                } else if (error.request) {
                  this.$toast.error('No response received from the server.');
                } else {
                  this.$toast.error(error);
                }
            });
        } else {
          this.$toast.warning("Please Fill All Required Fields");
        }
      },
      completeDemo(demo_id) {
        this.id = this.demo_notes[demo_id].id;
        let page_no = this.formData.pageNumber;
        let followup_date = this.formData.followup_date;
        this.$store.dispatch("modal/completeDemoForm", {
          action: "create",
          title: "Demo Complete",
          formData: { page_no, id:this.id, demo_id:this.formData.user, status: this.formData.status, followup_date: followup_date, followup_filter: this.formData.followup_filter },
          component: completeDemo,
        });
      },
        incompleteDemo(demo_id) {
        this.id = this.demo_notes[demo_id].id;
        let page_no = this.formData.pageNumber;
        let followup_date = this.formData.followup_date;
        this.$store.dispatch("modal/incompleteDemoForm", {
          action: "create",
          title: "Demo InComplete",
          formData: { page_no, id:this.id, demo_id:this.formData.user, status: this.formData.status, followup_date: followup_date, followup_filter: this.formData.followup_filter },
          component: incompleteDemo,
        });
      },
      getDemoNote() {
        const permission = {
        headers: {
          'X-Permission': 'lead_set_demo_date' 
        }
      };
        axios
          .get("/admin/users/get-demo-note?user_id=" + this.formData.user,permission)
          .then((response) => {
            let data = response.data.demo_notes;
            if (data != null) {
              this.demo_notes = data;
            }

            this.demo_date = new Date();
            this.demo_date = moment(String(this.demo_date)).format('YYYY-MM-DDThh:mm')
          });
      },
    },
  };
</script>